import { TypedDocumentNode, gql } from '@apollo/client';

type SubmitCSAFeedbackVariables = {
  alias: string;
  date: string;
  isSummaryGood: boolean;
  summaryUUID: string;
};

export type SubmitCSAFeedbackResponse = {
  submitCSASummariesCSAFeedback: {
    success: boolean;
    message: string;
    error: string;
  };
};

export const submitCSASummariesCSAFeedback: TypedDocumentNode<
  SubmitCSAFeedbackResponse,
  SubmitCSAFeedbackVariables
> = gql`
  mutation SubmitCSASummariesCSAFeedback(
    $alias: String!
    $date: String!
    $isSummaryGood: Boolean!
    $summaryUUID: String!
  ) {
    submitCSASummariesCSAFeedback(
      alias: $alias
      date: $date
      isSummaryGood: $isSummaryGood
      summaryUUID: $summaryUUID
    ) {
      success
      message
      error
    }
  }
`;

export const submitCSASummariesManagerFeedback = gql`
  mutation SubmitCSASummariesManagerFeedback(
    $alias: String!
    $csaAlias: String!
    $date: String!
    $feedback: ManagerFeedbackInput!
    $summaryUUID: String!
  ) {
    submitCSASummariesManagerFeedback(
      alias: $alias
      csaAlias: $csaAlias
      date: $date
      feedback: $feedback
      summaryUUID: $summaryUUID
    ) {
      success
      message
      error
    }
  }
`;
